import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ViewChild, ViewEncapsulation } from "@angular/core";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-course-list",
  templateUrl: "./course-list.component.html",
  styleUrls: [
    "./course-list.component.scss",
    "../../../../../../assets/sass/libs/datatables.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CourseListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0,
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  searchVal: any;
  isFilter: boolean = false;
  // column header
  public columns = [
    { name: "Title", prop: "title" },
    { name: "Fees", prop: "total_fees" },
    { name: "Actions", prop: "Actions" },
  ];
  // private
  private tempData = [];
  imageUrl = environment.apiUrls.course_imageUrl;
  course_id: any;
  @ViewChild("name") inputName;
  user_role: any;
  isActivated: boolean;

  guideline_data: any;

  public courseTypeView: boolean[] = [];
  course_variant_id = null;
  variationList = [];
  row_name = "";
  row_id: any;
  selectedVariation = null;
  empType = [];
  statusList = [
    { name: "Current", id: "current" },
    { name: "Archived", id: "archived" },
  ];
  activeTab = "";
  mode_List = [];
  selected_mode = null;
  duration_List = [];
  durationId = "631ad5d2ce5c666542591b40";
  selected_duration = null;
  key_id_forUpdateCourse: any;
  btn_props: any;
  category_list = [];
  selected_category_tab = null;
  selected_tag_tab = null;
  tags_list = [];
  total_course_count;
  constructor(
    public apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,
    private route: Router,
    private activerouter: ActivatedRoute,
  ) {
    this.getAllCategory();

    this.user_role = JSON.parse(localStorage.getItem("user"));
    if (this.user_role.roles !== "admin") {
      this.empType = this.user_role.employeetype.map(
        (item) => item.displayname
      );
    }
    this.activerouter.queryParamMap.subscribe((params: any) => {
      this.activeTab = params.get("status")
      this.selected_category_tab = params.get('category');
      if (this.activeTab && this.selected_category_tab) {
        this.getCourseList(this.activeTab, this.selected_category_tab);
      }
      else this.activeCourseTab("current", "65267fd3a20f03fb8efe63d1");
    });
    this.filterSetting2("Courses");
    this.filterSetting("publisher_password");

  }

  ngOnInit(): void {
    this.getDurationTagByCategory();
    this.setAndGetEmployeebyStatus();
  }
  activeCourseTab(tab, category) {
    const activetab = tab;
    this.selected_category_tab = category
    this.activeTab = tab;
    if (activetab !== "") {
      this.route.navigate([], {
        relativeTo: this.activerouter,
        queryParams: { status: activetab, category: this.selected_category_tab },
        queryParamsHandling: 'merge'
      });
    }
  }
  setAndGetEmployeebyStatus() {
    this.activerouter.queryParams.subscribe((params: any) => {
      this.activeTab = params?.status;
      this.selected_category_tab = params?.category;
      this.getCourseList(this.activeTab, this.selected_category_tab);
    });
  }

  viewCourse(id) { }
  editCourse(id) {
    window.open(`/course/course-add-edit?id=${id}`);
  }
  getCourseList(active_tab, category) {
    this.activeTab = active_tab
    this.selected_category_tab = category
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    if (this.selected_category_tab && this.selected_tag_tab === null) {
      this.selected_tag_tab = "all";
    }

    this.apiService
      .getCourseGroupingListByCategory(
        this.activeTab,
        this.selected_category_tab
          ? this.selected_category_tab === "all"
            ? ""
            : this.selected_category_tab
          : "",
        this.selected_tag_tab
          ? this.selected_tag_tab === "all"
            ? ""
            : this.selected_tag_tab
          : "",
        this.page.pageNumber + 1,
        this.limitRef
      )
      .subscribe((res: any) => {
        this.spinner.hide();
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.filterCount;
        this.total_course_count = res?.data?.totalCount;
      });
  }
  pageChangeData(page: any) {
    this.apiService
      .getCourseList(page.offset + 1, page.pageSize)
      .subscribe((res: any) => {
        this.rows = res.data.items;
        this.page.totalPages = res.data.totalCount;
      });
  }
  getCourseFilter(data: any) {
    let name = data;
    if (name) {
      this.apiService.getCourseGroupingSearch(name).subscribe((res: any) => {
        this.rows = res?.data?.items;
        this.page.totalPages = res?.data?.totalCount;
      });
    } else {
      this.setAndGetEmployeebyStatus();
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = "";
    this.selected_category_tab = "65267fd3a20f03fb8efe63d1";
    this.selected_tag_tab = "all";
    this.setAndGetEmployeebyStatus();
  }

  // ================== Delete Alert ========================
  Delete(id: any) {
    this.course_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.deleteCourse(result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Your file is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  deleteCourse(password) {
    this.apiService
      .courseDelete(this.course_id, password)
      .subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Your file has been deleted.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.setAndGetEmployeebyStatus();
        } else {
          swal.fire({
            icon: "error",
            title: "Error!",
            text: `${res.error}`,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  // =================lms link=========================
  openInNewTab(password, id, value): void {
    if (password == value) window.open(`/lmss?id=${id}`, "_blank");
    else {
      swal.fire({
        icon: "error",
        title: "Error!",
        text: "Incorrect Password!",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
    // window.open(`/lmss-new?id=${id}`, '_blank');
  }
  publishUnpublishWeb(data) {
    var id = data?._id;
    this.isActivated = data?.published_web;
    let model = {
      published_web: this.isActivated ? false : true,
    };
    this.apiService.updateCourse(id, model).subscribe((res: any) => {
      if (res.isSuccess === true) {
        this.toastr.success(res.message);
        this.setAndGetEmployeebyStatus();
      } else {
        this.toastr.error(res.error);
      }
    });
  }
  publishUnpublishApp(data) {
    var id = data?._id;
    this.isActivated = data?.published_app;
    let model = {
      published_app: this.isActivated ? false : true,
    };
    this.apiService.updateCourse(id, model).subscribe((res: any) => {
      if (res.isSuccess === true) {
        this.toastr.success(res.message);
        this.setAndGetEmployeebyStatus();
      } else {
        this.toastr.error(res.error);
      }
    });
  }

  openDynamicModal(key_id: string) {
    const modalOptions: NgbModalOptions = {
      size: "lg", // 'sm', 'lg', or 'xl'
      backdrop: "static",
    };
    const modalRef = this.modalService.open(
      DynamicDetailComponent,
      modalOptions
    );
    modalRef.componentInstance.key_id = key_id;
  }
  copyCourseLinkMeanderTraining(row) {
    const slug = row.slug || row._id;
    let link = `https://learn.meander.software/course-details/${slug}`;
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.toastr.info("Meander training link copied");
  }
  copyCourseLinkMeanderSoftware(row) {
    const slug = row.slug || row._id;
    let link = `https://learn.meander.software/course-details/${slug}`;
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
    this.toastr.info("Learn meander software link copied");
  }
  getAllCategory() {
    this.apiService.getAllCategory(1, 1000).subscribe((res: any) => {
      let mode = res?.data?.items?.filter(
        (item) => item.name == "learningmode"
      );
      if (mode) {
        this.apiService
          .getTagByTagCatgoryId(mode[0]._id)
          .subscribe((res: any) => {
            this.mode_List = res.data;
          });
      }
      let course_variant = res?.data?.items.filter(
        (item) => item.name == "course_variant"
      );
      this.course_variant_id = course_variant[0]?._id;
      if (this.course_variant_id) {
        this.getVariationTagByCategory();
      }

      this.category_list = res?.data?.items.filter(
        (item) =>
          item.name == "Internal Program" ||
          item.name == "academicprogram" ||
          item.name == "industrial_program" ||
          item.name == "certification_program"
      );

      this.category_list.sort((a, b) => {
        if (a.displayname < b.displayname) {
          return -1;
        }
        if (a.displayname > b.displayname) {
          return 1;
        }
        return 0;
      });
      if (this.selected_category_tab == null) {
        this.selected_category_tab = "65267fd3a20f03fb8efe63d1";
        this.selected_tag_tab = "all";
        this.getPublishTagsByPublishCategory(this.selected_category_tab);
      }
      if (this.selected_category_tab != null) {
        this.selected_tag_tab = "all";
        this.getPublishTagsByPublishCategory(this.selected_category_tab);
      }

    });
  }
  getVariationTagByCategory() {
    this.apiService
      .getTagByTagCatgoryId(this.course_variant_id)
      .subscribe((res: any) => {
        this.variationList = res?.data;
      });
  }
  openModalForReferral(content, name, id, variation_id) {
    this.row_id = id;
    this.row_name = name;
    this.selectedVariation = variation_id;
    const options: NgbModalOptions = {
      size: "md", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.row_id = null;
        this.row_name = null;
        this.selectedVariation = null;
      },
      (reason) => {
        this.row_id = null;
        this.row_name = null;
        this.selectedVariation = null;
      }
    );
  }
  updateVariation() {
    let formData = new FormData();
    formData.append("variations", this.selectedVariation),
      this.apiService
        .updateCourse(this.row_id, formData)
        .subscribe((res: any) => {
          if (res.isSuccess === true) {
            this.toastr.success(res.message);
            this.modalService.dismissAll();
            this.setAndGetEmployeebyStatus();
          } else {
            this.toastr.error(res.error);
          }
        });
  }
  updateStatus(id, status) {
    let formData = new FormData();
    formData.append("course_status", status);
    if (id) {
      this.apiService.updateCourse(id, formData).subscribe((res: any) => {
        if (res.isSuccess === true) {
          this.toastr.success(res.message);
          this.modalService.dismissAll();
          this.setAndGetEmployeebyStatus();
        } else {
          this.toastr.error(res.error);
        }
      });
    }
  }
  getDurationTagByCategory() {
    this.apiService
      .getTagByTagCatgoryId(this.durationId)
      .subscribe((res: any) => {
        this.duration_List = res?.data;
      });
  }
  getModeId(event) {
    this.selected_mode;
  }
  getDurationId(event) {
    this.selected_duration;
  }
  openMode(content, id, mode) {
    this.row_id = id;
    this.selected_mode = mode.map((item) => item._id);
    const options: NgbModalOptions = {
      size: "md", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.row_id = null;
        this.selected_mode = null;
      },
      (reason) => {
        this.row_id = null;
        this.selected_mode = null;
      }
    );
  }
  openDuration(content, id, duration) {
    this.row_id = id;
    this.selected_duration = duration._id;
    const options: NgbModalOptions = {
      size: "md", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };

    const modalRef = this.modalService.open(content, options);

    modalRef.result.then(
      (result) => {
        this.row_id = null;
        this.selected_duration = null;
      },
      (reason) => {
        this.row_id = null;
        this.selected_duration = null;
      }
    );
  }
  updateMode() {
    let formData = new FormData();
    this.selected_mode.forEach((mode, index) => {
      formData.append(`course_mode[${index}]`, mode);
    });
    if (this.row_id) {
      this.apiService
        .updateCourse(this.row_id, formData)
        .subscribe((res: any) => {
          if (res.isSuccess === true) {
            this.toastr.success(res.message);
            this.modalService.dismissAll();
            this.setAndGetEmployeebyStatus();
          } else {
            this.toastr.error(res.error);
          }
        });
    }
  }
  updateDuration() {
    let formData = new FormData();
    formData.append("duration", this.selected_duration);
    if (this.row_id) {
      this.apiService
        .updateCourse(this.row_id, formData)
        .subscribe((res: any) => {
          if (res.isSuccess === true) {
            this.toastr.success(res.message);
            this.modalService.dismissAll();
            this.setAndGetEmployeebyStatus();
          } else {
            this.toastr.error(res.error);
          }
        });
    }
  }
  // ================== Update Course Alert ========================
  confirmUpdate(id: any, prop: any, row_value) {
    this.course_id = id;
    this.btn_props = prop;


    // if (this.btn_props == 'edit course') {
    swal
      .fire({
        text: "Please Enter Publisher Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.passwordToCourse(result.value, id);
        }
        else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            text: "Cancel",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    // }
    // if (this.btn_props == 'view lms') { 
    //   if(row_value =='' || row_value ==null || row_value ==undefined){
    //     window.open(`/lmss?id=${id}`, "_blank");
    //   }
    //   else {
    //     swal
    //   .fire({
    //     text: "Please Enter Read Password",
    //     input: "password",
    //     showCancelButton: true,
    //   })
    //   .then((result) => {
    //     if (result.value) {
    //       this.openInNewTab(result.value, this.course_id,row_value);
    //     }
    //     else if (result.dismiss === swal.DismissReason.cancel) {
    //       swal.fire({
    //         title: "Cancelled",
    //         text: "Cancel",
    //         icon: "error",
    //         customClass: {
    //           confirmButton: "btn btn-success",
    //         },
    //       });
    //     }
    //   });
    //   }

    // }
    // if (this.btn_props == 'student lms') { 
    //   if(row_value =='' || row_value ==null || row_value ==undefined){
    //     window.open(`/lmss?id=${id}`, "_blank");
    //   }
    //   else {
    //     swal
    //   .fire({
    //     text: "Please Enter Read Password",
    //     input: "password",
    //     showCancelButton: true,
    //   })
    //   .then((result) => {
    //     if (result.value) {
    //       this.studentLmsNewTab(result.value, this.course_id,row_value);
    //     }
    //     else if (result.dismiss === swal.DismissReason.cancel) {
    //       swal.fire({
    //         title: "Cancelled",
    //         text: "Cancel",
    //         icon: "error",
    //         customClass: {
    //           confirmButton: "btn btn-success",
    //         },
    //       });
    //     }
    //   });
    //   }
    // }

  }
  passwordToCourse(password, id) {
    this.apiService
      .passwordToUpdateCourse(this.key_id_forUpdateCourse, password)
      .subscribe((res: any) => {
        if (res.statusCode === 200 && res.data === true) {
          if (this.btn_props === "edit course") {
            this.editCourse(this.course_id);
          }
          if (this.btn_props === "edit lms") {
            window.open(`/lmss?id=${id}`, "_blank");
          }
          if (this.btn_props === "student lms") {
            window.open(`/student-lms?id=${id}`, "_blank");
          }
        } else {
          swal.fire({
            icon: "error",
            title: "Error!",
            text: "Incorrect Password!",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  filterSetting(data) {
    this.apiService.searchSettings(data).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.key_id_forUpdateCourse = res?.data?.items[0]?._id;
      }
    });
  }
  filterSetting2(data) {
    this.apiService.searchSettings(data).subscribe((res: any) => {
      if (res?.statusCode === 200) {
        this.guideline_data = res?.data?.items[0]?._id;
      }
    });
  }
  studentLmsNewTab(password, id, value): void {
    if (password == value) this.isCoursePassword(password, id)
    else {
      swal.fire({
        icon: "error",
        title: "Error!",
        text: "Incorrect Password!",
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    }
    // window.open(`/student-lms?id=${id}`, "_blank");
  }
  isCoursePassword(id, password) {
    this.apiService.getCourseIsPassword(id).subscribe((res: any) => {
      console.log(res);
    });
  }
  getChangeCategory(event) {
    if (this.selected_category_tab) {
      this.route.navigate([], {
        relativeTo: this.activerouter,
        queryParams: { category: this.selected_category_tab },
        queryParamsHandling: 'merge' // keep existing query params
      });
      this.selected_tag_tab = "all";
      this.getPublishTagsByPublishCategory(this.selected_category_tab);
      this.setAndGetEmployeebyStatus();

    }
  }
  getPublishTagsByPublishCategory(id) {
    if (id) {
      this.apiService.getTagByTagCatgoryId(id).subscribe((res: any) => {
        this.tags_list = res.data;
        let tag = { _id: "all", displayname: "All" };
        this.tags_list.push(tag);
        this.tags_list.sort((a, b) => {
          if (a.displayname < b.displayname) {
            return -1;
          }
          if (a.displayname > b.displayname) {
            return 1;
          }
          return 0;
        });
      });
    }
  }
  getChangeTag(event) {
    this.selected_tag_tab;
    this.setAndGetEmployeebyStatus();
  }
  toggleCollapse(index: number) {
    this.courseTypeView[index] = !this.courseTypeView[index];
  }
}
